import { ModalAddCompComponent } from './../../../shared/components/modals/modal-add-comp/modal-add-comp.component';
import { GestionReferentielComponentService } from './../gestion-referentiel-component.service';
import { TypeCompModel } from '../../../shared/models/simple-types/type-comp.model';
import { TypeCompService } from '../../../shared/services/simple/type-comp.service';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { CompModel } from 'src/app/shared/models/societe-linked/comp.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { CompService } from 'src/app/shared/services/societe-linked/comp.service';

@Component({
  selector: 'app-gestion-comp',
  templateUrl: './gestion-comp.component.html',
  styleUrls: ['./gestion-comp.component.scss']
})
export class GestionCompComponent{

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  societe: SocieteModel;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: CompModel;
  displayedColumns: string[] = ['code', 'libelle', 'type', 'action'];
  dataSource: CompModel[];
  matDataSource = new MatTableDataSource<CompModel>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  comps: CompModel[] = [];
  typeComps: TypeCompModel[] = [];

  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private gestionReferentielComponentService: GestionReferentielComponentService,
    private typeCompService: TypeCompService,
    injector: Injector,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private compService: CompService,
    private societeService: SocieteService,
    private toastrService: ToastrService,
  )
  {
    this.route.params.subscribe((params: any) => {
      if (params.id === '0') {
        this.toastrService.error('Erreur durant la récupération du complément.', 'Erreur');
        this.router.navigate(['/']);
      } else {
        this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
          if (societe) {
           this.societe = societe;
           this.objet.query = '';
           this.objet.pageNumber = 0;
           this.objet.pageSize = this.pageSize;
           this.objet.order = 'libelle';
           this.matDataSource.paginator = this.paginator;
           this.loadPage();
           typeCompService.getAll().subscribe(types => {
              this.typeComps = types;
            });
          }
        });
      }
    });

    this.router.routeReuseStrategy.shouldReuseRoute = function() {
       return false;
     };
    this.mySubscription = this.router.events.subscribe((event) => {
       if (event instanceof NavigationEnd) {
         this.router.navigated = false;
       }
     });
  }

  onCreate(): void {
    const form = this.gestionReferentielComponentService.getCreateCompFormGroup();
    form.get('idSociete').setValue(this.societe.id);
    const dialogRef = this.dialog.open(ModalAddCompComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          comps: this.comps,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });

  }

  onModify(comp: CompModel): void {
    const form = this.gestionReferentielComponentService.getEditCompFormGroup(comp);
    const dialogRef = this.dialog.open(ModalAddCompComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          comps: this.comps,
          typeComp: comp.typeComp,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
          this.loadPage();
        }
      });
  }


  onDelete(comp: CompModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression du complément',
        message: 'Êtes-vous sur de vouloir supprimer le complément ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.compService.delete(comp.id).subscribe((response: CompModel) => {
          this.toastrService.success('Le complément a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  orderUsers(comps: CompModel[]): CompModel[] {
    comps = comps.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return comps;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.societe.id;
    this.compService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<CompModel>) => {
      if (query.objets != null) {
        this.comps = query.objets;
      } else {
        this.comps = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<CompModel>(this.comps);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}
